"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ContentDelivery = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _index = require("../index");

var _axios = _interopRequireDefault(require("axios"));

var _axiosCancel = _interopRequireDefault(require("axios-cancel"));

var _lodash = _interopRequireDefault(require("lodash"));

var _qs = _interopRequireDefault(require("qs"));

var _storage = _interopRequireDefault(require("./storage"));

var _imagePreloader = _interopRequireDefault(require("./imagePreloader"));

var _fileCache = _interopRequireDefault(require("./fileCache"));

var _reactNativeHtmlParser = require("react-native-html-parser");

var _config = require("../config");

var _retriable = _interopRequireDefault(require("../utils/retriable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

(0, _axiosCancel["default"])(_axios["default"]);
/**
 * Tweddle Content Delivery API
 */

var ContentDelivery = /*#__PURE__*/function () {
  // there should be only one singleton auth request at the time

  /**
   * Initiates bindings
   */
  function ContentDelivery() {
    _classCallCheck(this, ContentDelivery);

    _defineProperty(this, "authRequest", null);

    this.endpoints = {
      AUTH: '/api/v2/auth/token',
      VEHICLES: '/api/v2/info/vehicles',
      CONTENTS: '/api/v2/contents',
      CONTENTS_SEARCH: '/api/v2/contents/search',
      HEROSHOTS: '/api/v2/contents/heroShots',
      ASSETS: '/api/v2/assets/downloads/objectKey',
      VEHICLES_INTERNAL: '/api/v2/internal/info/vehicles',
      CONTENTS_INTERNAL: '/api/v2/internal/contents',
      CONTENTS_SEARCH_INTERNAL: '/api/v2/internal/contents/search'
    };
    this.setStorage(_storage["default"]); // the irony of ES2017 is that old good bindAll from 2010, invented by BackboneJS team, still needed in 2017

    _lodash["default"].bindAll(this, 'initSession', 'requestFailed', 'getVehicles', 'get');
  }
  /**
   * Set storage instance
   *
   * @param {object} storage
   */


  _createClass(ContentDelivery, [{
    key: "setStorage",
    value: function setStorage(storage) {
      this.storage = storage;
    }
    /**
     * Content delivery service auth singleton request
     *
     * @param {String} clientId user login
     * @param {String} clientSecret user password
     * @returns {Promise} on login action
     */

  }, {
    key: "authSession",
    value: function () {
      var _authSession = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(clientId, clientSecret) {
        var isNew, response, result;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                isNew = true;

                if (!this.authRequest) {
                  this.authRequest = this.auth(clientId, clientSecret);
                } else {
                  isNew = false;
                }

                _context.next = 5;
                return this.authRequest;

              case 5:
                response = _context.sent;
                result = isNew ? this.initSession(response) : this.authRequest.then();
                this.authRequest = null;
                return _context.abrupt("return", result);

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                this.authRequest = null;
                throw _context.t0;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function authSession(_x, _x2) {
        return _authSession.apply(this, arguments);
      }

      return authSession;
    }()
    /**
     * Content delivery service auth
     *
     * @param {String} clientId user login
     * @param {String} clientSecret user password
     * @returns {Promise} on login action
     */

  }, {
    key: "auth",
    value: function auth(clientId, clientSecret) {
      var _getConfig = (0, _index.getConfig)(),
          COOKIE_AUTHENTICATION = _getConfig.COOKIE_AUTHENTICATION;

      return _axios["default"].post(this.endpoints.AUTH, _qs["default"].stringify({
        'grant_type': 'client_credentials',
        'client_id': clientId,
        // App.config.clientId,
        'client_secret': clientSecret // App.config.clientSecret

      }), COOKIE_AUTHENTICATION ? {
        // we should receive an auth cookie from CD
        headers: {
          'tw-cookie-authentication': 'true'
        },
        withCredentials: true
      } : {});
    }
    /**
     * Send request to internal API or external URL
     *
     * @param {Object} params
     * @return {Promise} when request is initiated
     */

  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2(params) {
        var _this = this;

        var _getConfig2, CLIENT_ID, CLIENT_SECRET, isAuthNeeded, isRetriable, requestMethod;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _getConfig2 = (0, _index.getConfig)(), CLIENT_ID = _getConfig2.CLIENT_ID, CLIENT_SECRET = _getConfig2.CLIENT_SECRET;
                isAuthNeeded = true;
                isRetriable = params.retriable;
                delete params.retriable;
                isRetriable = isRetriable !== false; // loading external url or no auth credentials provided

                if (!this.isInternalUrl(params.url) || !CLIENT_ID || !CLIENT_SECRET) {
                  isAuthNeeded = false;
                }

                requestMethod = isAuthNeeded ? function () {
                  return _this.getAuthenticated(params);
                } : function () {
                  return _axios["default"].request(params);
                };

                if (!isRetriable) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", _retriable["default"].request(requestMethod, _objectSpread(_objectSpread({}, params.requestId ? {
                  requestId: params.requestId
                } : {}), params.requestGroup ? {
                  requestGroup: params.requestGroup
                } : {})));

              case 11:
                return _context2.abrupt("return", requestMethod());

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
    /**
     * Request wrapper that adds auth headers to internal requests
     *
     * @param {Object} params
     * @param {String} accessToken optional parameter in case when client already contains access token
     * @returns {Promise}
     */

  }, {
    key: "getAuthenticated",
    value: function () {
      var _getAuthenticated = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(params) {
        var accessToken,
            _getConfig3,
            CLIENT_ID,
            CLIENT_SECRET,
            accessTokenExpiration,
            authParams,
            _args3 = arguments;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                accessToken = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;
                _getConfig3 = (0, _index.getConfig)(), CLIENT_ID = _getConfig3.CLIENT_ID, CLIENT_SECRET = _getConfig3.CLIENT_SECRET; // Init session if its not authenticated

                if (accessToken) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 5;
                return this.storage.getItem('accessToken');

              case 5:
                accessToken = _context3.sent;
                _context3.t0 = parseInt;
                _context3.next = 9;
                return this.storage.getItem('accessTokenExpiration');

              case 9:
                _context3.t1 = _context3.sent;
                accessTokenExpiration = (0, _context3.t0)(_context3.t1, 10);

                if (!(!accessToken || !accessTokenExpiration || accessTokenExpiration < new Date().getTime())) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 14;
                return this.authSession(CLIENT_ID, CLIENT_SECRET);

              case 14:
                accessToken = null;

              case 15:
                _context3.t2 = _objectSpread;
                _context3.t3 = _objectSpread({}, params);
                _context3.t4 = {};
                _context3.next = 20;
                return this.getAuthHeaders(accessToken);

              case 20:
                _context3.t5 = _context3.sent;
                _context3.t6 = {
                  headers: _context3.t5
                };
                authParams = (0, _context3.t2)(_context3.t3, _context3.t4, _context3.t6);
                return _context3.abrupt("return", _axios["default"].request(authParams)["catch"](this.requestFailed));

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAuthenticated(_x4) {
        return _getAuthenticated.apply(this, arguments);
      }

      return getAuthenticated;
    }()
    /**
     * Returns auth headers
     *
     * @param {String} accessToken
     * @return {Promise<{Authorization: string}>}
     */

  }, {
    key: "getAuthHeaders",
    value: function () {
      var _getAuthHeaders = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var accessToken,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                accessToken = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;

                if (accessToken) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 4;
                return this.storage.getItem('accessToken');

              case 4:
                accessToken = _context4.sent;

              case 5:
                return _context4.abrupt("return", {
                  'Authorization': 'Bearer ' + accessToken
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAuthHeaders() {
        return _getAuthHeaders.apply(this, arguments);
      }

      return getAuthHeaders;
    }()
    /**
     * Store session data in-memory on successful authentication
     *
     * @param {Object} response
     */

  }, {
    key: "initSession",
    value: function () {
      var _initSession = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee5(response) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.storage.setItem('accessToken', response.data.accessToken);

              case 2:
                _context5.next = 4;
                return this.storage.setItem('accessTokenExpiration', String(new Date().getTime() + response.data.expiresIn * 1000));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function initSession(_x5) {
        return _initSession.apply(this, arguments);
      }

      return initSession;
    }()
    /**
     * Clears session data allowing user to re-login
     *
     * @returns {Promise<void>}
     */

  }, {
    key: "clearSession",
    value: function () {
      var _clearSession = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.storage.removeItem('accessToken');

              case 2:
                _context6.next = 4;
                return this.storage.removeItem('accessTokenExpiration');

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function clearSession() {
        return _clearSession.apply(this, arguments);
      }

      return clearSession;
    }()
    /**
     * Authentication failure
     *
     * @param {Object} data
     * @returns {Promise.<*>}
     */

  }, {
    key: "requestFailed",
    value: function () {
      var _requestFailed = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee7(data) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(data.response && data.response.status === 403)) {
                  _context7.next = 3;
                  break;
                }

                _context7.next = 3;
                return this.clearSession();

              case 3:
                return _context7.abrupt("return", Promise.reject(data));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function requestFailed(_x6) {
        return _requestFailed.apply(this, arguments);
      }

      return requestFailed;
    }()
    /**
     * Returns the list of supported vehicles
     *
     * @return {Promise}
     */

  }, {
    key: "getVehicles",
    value: function getVehicles() {
      var _getConfig4 = (0, _index.getConfig)(),
          FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW = _getConfig4.FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW,
          REQUEST_ID_VEHICLES = _getConfig4.REQUEST_ID_VEHICLES;

      return this.get({
        url: FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW ? this.endpoints.VEHICLES_INTERNAL : this.endpoints.VEHICLES,
        requestId: REQUEST_ID_VEHICLES
      });
    }
    /**
     *
     * Get hero shot contents available for a vehicle
     *
     * @param {String} brand
     * @param {String} year
     * @param {String} model
     * @param {String} locale
     * @return {Promise}
     */

  }, {
    key: "getHeroShots",
    value: function getHeroShots(brand, year, model, locale) {
      var params = {
        make: brand,
        model: model,
        year: year,
        locale: locale
      };
      return this.get({
        url: this.endpoints.HEROSHOTS,
        params: params
      });
    }
    /**
     * Retrieves available content for a vehicle
     *
     * @param {String} brand
     * @param {String} year
     * @param {String} model
     * @param {String} locale
     * @param {String} searchText
     * @return {Promise}
     * @deprecated
     */

  }, {
    key: "getContents",
    value: function getContents(brand, year, model, locale) {
      var searchText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var _getConfig5 = (0, _index.getConfig)(),
          REQUEST_ID_SEARCH = _getConfig5.REQUEST_ID_SEARCH,
          REQUEST_ID_CONTENTS = _getConfig5.REQUEST_ID_CONTENTS,
          FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW = _getConfig5.FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW;

      var params = {
        make: brand,
        year: year,
        model: model,
        locale: locale
      }; // search text param is optional

      if (!_lodash["default"].isEmpty(searchText)) {
        params.contains = searchText;
      }

      return this.get({
        url: FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW ? this.endpoints.CONTENTS_INTERNAL : this.endpoints.CONTENTS,
        requestId: searchText ? REQUEST_ID_SEARCH : REQUEST_ID_CONTENTS,
        params: params
      }).then(function (res) {
        if (!res) {
          // request was canceled by user, lets return earlier
          return null;
        }

        return FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW ? api.filterDraftContent(res.data) : res.data;
      });
    }
    /**
     * Retrieves available content for a vehicle by it's ID
     *
     * @param {String} vehicleId
     * @param {String} locale
     * @param {String} searchText
     * @return {Promise}
     */

  }, {
    key: "getContentsByVehicleId",
    value: function getContentsByVehicleId(vehicleId, locale) {
      var searchText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var _getConfig6 = (0, _index.getConfig)(),
          REQUEST_ID_SEARCH = _getConfig6.REQUEST_ID_SEARCH,
          REQUEST_ID_CONTENTS = _getConfig6.REQUEST_ID_CONTENTS,
          FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW = _getConfig6.FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW;

      var params = {
        vehicleId: vehicleId,
        locale: locale
      }; // search text param is optional

      if (!_lodash["default"].isEmpty(searchText)) {
        params.contains = searchText;
      }

      return this.get({
        url: FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW ? this.endpoints.CONTENTS_INTERNAL : this.endpoints.CONTENTS,
        requestId: searchText ? REQUEST_ID_SEARCH : REQUEST_ID_CONTENTS,
        params: params
      }).then(function (res) {
        if (!res) {
          // request was canceled by user, lets return earlier
          return null;
        }

        return FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW ? api.filterDraftContent(res.data) : res.data;
      });
    }
    /**
     * Retrieves available content for a vehicle by it's ID ordered by relevance to search phrase
     *
     * @param {String} vehicleId
     * @param {String} locale
     * @param {String} contains
     * @return {Promise}
     */

  }, {
    key: "searchContentsByVehicleId",
    value: function () {
      var _searchContentsByVehicleId = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee8(vehicleId, locale, contains) {
        var _getConfig7, FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW;

        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _getConfig7 = (0, _index.getConfig)(), FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW = _getConfig7.FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW;
                _context8.t0 = _axios["default"];
                _context8.t1 = FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW ? this.endpoints.CONTENTS_SEARCH_INTERNAL : this.endpoints.CONTENTS_SEARCH;
                _context8.t2 = JSON.stringify({
                  vehicleId: vehicleId,
                  locale: locale,
                  contains: contains
                });
                _context8.t3 = _objectSpread;
                _context8.t4 = _objectSpread;
                _context8.t5 = {};
                _context8.next = 9;
                return this.getAuthHeaders();

              case 9:
                _context8.t6 = _context8.sent;
                _context8.t7 = (0, _context8.t4)(_context8.t5, _context8.t6);
                _context8.t8 = {};
                _context8.t9 = {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                };
                _context8.t10 = (0, _context8.t3)(_context8.t7, _context8.t8, _context8.t9);
                _context8.t11 = {
                  headers: _context8.t10
                };
                return _context8.abrupt("return", _context8.t0.post.call(_context8.t0, _context8.t1, _context8.t2, _context8.t11).then(function (res) {
                  if (!res) {
                    // request was canceled by user, lets return earlier
                    return null;
                  }

                  return FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW ? api.getDraftContent(res.data.items) : res.data.items;
                }));

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function searchContentsByVehicleId(_x7, _x8, _x9) {
        return _searchContentsByVehicleId.apply(this, arguments);
      }

      return searchContentsByVehicleId;
    }()
    /**
     * Processes Content Delivery response to contain only the latest DRAFT or PUBLISHED content
     *
     * @param {Object} data
     * @returns {Object}
     */

  }, {
    key: "filterDraftContent",
    value: function filterDraftContent(data) {
      var _this2 = this;

      // return early if there is no any publications available
      // this happens in case of coming soon models and when search results are received
      if (!data.publications) {
        return data;
      } // run through content types and build new data object by filtering only content from the recent transform runs


      var draftContent = Object.keys(data).reduce(function (newData, contentType) {
        if (data[contentType]) {
          newData[contentType] = _this2.getDraftContent(data[contentType]);
        }

        return newData;
      }, {}); // topics and folders are not the top-level content types but are sub-contents of the publications
      // extract the list of the extIds to filter the remaining content against

      var latestPubsExtIds = draftContent.publications.map(function (x) {
        return x.extId;
      }); // so in order to get the proper content hierarchy, we need to filter topics/folders by corresponding extIds

      var guideContent = ['topics', 'folders'].reduce(function (newData, contentType) {
        if (data[contentType]) {
          newData[contentType] = data[contentType].filter(function (x) {
            return latestPubsExtIds.includes(x.extId);
          });
        }

        return newData;
      }, {}); // lets merge two results together

      return _objectSpread(_objectSpread({}, draftContent), guideContent);
    }
    /**
     * Strips our the old content, leaving only the latest version of each item identified by resourceKey
     *
     * @param {Array} items
     * @return {Array}
     */

  }, {
    key: "getDraftContent",
    value: function getDraftContent(items) {
      // keep only the content that is draft [used in draft preview mode]
      var contents = items.filter(function (x) {
        return x.state && x.state.current ? x.state.current === _config.CONTENTS_STATUS_DRAFT : true;
      }); // grab all the unique resourceKeys

      var uniqResourceKeys = _lodash["default"].uniq(contents.map(function (x) {
        return x.resourceKey;
      })); // there may be multiple versions of the same content, lets filter out the latest one for each resource key


      return uniqResourceKeys.map(function (resourceKey) {
        // get all versions of the same content
        var versions = contents.filter(function (x) {
          return x.resourceKey === resourceKey;
        }); // get the latest version of the content + last modified date (may be ex. multiple reprocessing of same version)

        return _lodash["default"].head(_lodash["default"].orderBy(versions, ['version', 'lastModifiedDate'], ['desc', 'desc']));
      });
    }
    /**
     * Downloads asset via direct URL
     *
     * @param {String} objectKey
     * @returns {Promise}
     */

  }, {
    key: "getHtmlAsset",
    value: function getHtmlAsset(objectKey) {
      return this.get({
        url: this.endpoints.ASSETS + '/' + objectKey
      });
    }
    /**
     * Gets a file from cache or downloads it to the local filesystem
     * @param {String} objectKey
     * @returns {Promise}
     */

  }, {
    key: "getFileAsset",
    value: function getFileAsset(objectKey) {
      return _fileCache["default"].get(objectKey);
    }
    /**
     * Load all imageMaps and return blob URLs once all are loaded
     *
     * @param {Array} imageMaps
     * @returns {Promise}
     */

  }, {
    key: "getImageMaps",
    value: function getImageMaps(imageMaps) {
      var _getConfig8 = (0, _index.getConfig)(),
          REQUEST_GROUP_IMAGEMAPS = _getConfig8.REQUEST_GROUP_IMAGEMAPS;

      return _imagePreloader["default"].preload(imageMaps.map(function (map) {
        return map.image.url;
      }), REQUEST_GROUP_IMAGEMAPS);
    }
    /**
     * Traverses the AST representation of HTML to find nodes that need to be post-processed
     *
     * @param {Object} htmlAst An AST representation of the HTML
     * @returns {Object}
     */

  }, {
    key: "getNodesToRemoveAndToPreloadFromHtml",
    value: function getNodesToRemoveAndToPreloadFromHtml(htmlAst) {
      var _this3 = this;

      var nodes = {
        toPreload: [],
        toRemove: []
      };

      var checkNode = function checkNode(node) {
        if (!_lodash["default"].isEmpty(node.childNodes)) {
          node.childNodes.forEach(function (child) {
            return checkNode(child);
          });
        }

        if (node.type !== 'text' && _this3.isRedundant(node)) {
          nodes.toRemove.push(node);
        }

        if (node.tagName === 'img') {
          nodes.toPreload.push(node);
        }
      };

      checkNode(htmlAst);
      return nodes;
    }
    /**
     * Recursivvly search the HTML AST tree node and return the first node that matches the predicate function
     *
     * @param {Object} node
     * @param {Function} predicate
     * @returns {Object} The found node
     */

  }, {
    key: "findNode",
    value: function findNode(node, predicate) {
      if (predicate(node)) return node;

      if (!_lodash["default"].isEmpty(node.childNodes)) {
        for (var i = 0; i < node.childNodes.length; i++) {
          var childBodyNode = this.findNode(node.childNodes[i], predicate);
          if (childBodyNode) return childBodyNode;
        }
      }
    }
    /**
     * Pre-processes HTML content:
     * - strips redundant tags
     * - pre-loads images to local cache using authentication
     *
     * TODO: move image pre-load into image component, to avoid blocking the HTML output and manage image cache cleanup
     *
     * @param {String} html
     * @returns {Promise<String>} modified HTML with tags cleaned and image URLs replaced to preloaded ones
     */

  }, {
    key: "processContent",
    value: function processContent(html) {
      var doc = new _reactNativeHtmlParser.DOMParser().parseFromString(this.replaceImageSources(html), 'text/html'); // pre-process all loaded tags and drop the redundant ones

      var toRemove = [];
      var toPreload = [];
      var tags = doc.getElementsByTagName('*');

      for (var i = 0; i < tags.length; i++) {
        var node = tags[i];
        node.namespaceURI = null;

        if (this.isRedundant(node)) {
          toRemove.push(node);
        }

        if (node.nodeName === 'img') {
          toPreload.push(node);
        }
      }

      _lodash["default"].each(toRemove, function (el) {
        el.parentNode.removeChild(el);
      }); // load images into local cache and update all src attributes accordingly


      var urlToImageMap = toPreload.reduce(function (acc, el) {
        acc[el.getAttribute('data-src')] = el;
        return acc;
      }, {});
      return _imagePreloader["default"].preload(_lodash["default"].keys(urlToImageMap)).then(function (urlsMap) {
        // run through all URLs and update images with new src
        _lodash["default"].each(toPreload, function (el) {
          el.setAttribute('src', urlsMap[el.getAttribute('data-src')]);
          el.removeAttribute('data-src');
        });

        var body = doc.getElementsByTagName('body')[0]; // finally dump modified DOM into HTML string

        return new _reactNativeHtmlParser.XMLSerializer().serializeToString(body).replace(/<\/?body\/?>/ig, '');
      });
    }
  }, {
    key: "processHeroShots",
    value: function () {
      var _processHeroShots = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee9(heroShots, imageSize) {
        var _getConfig9, SKIP_PRELOAD_HEROSHOT_IMAGE, heroShot, heroShotFile, heroShotUrl, urlMap;

        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _getConfig9 = (0, _index.getConfig)(), SKIP_PRELOAD_HEROSHOT_IMAGE = _getConfig9.SKIP_PRELOAD_HEROSHOT_IMAGE;
                heroShot = heroShots[0];
                heroShotFile = heroShot.file.variants && heroShot.file.variants[imageSize] ? heroShot.file.variants[imageSize] : heroShot.file;
                heroShotUrl = heroShotFile.url;

                if (!SKIP_PRELOAD_HEROSHOT_IMAGE) {
                  _context9.next = 6;
                  break;
                }

                return _context9.abrupt("return", heroShotUrl);

              case 6:
                _context9.next = 8;
                return _imagePreloader["default"].preload([heroShotUrl]);

              case 8:
                urlMap = _context9.sent;
                return _context9.abrupt("return", urlMap[heroShotUrl]);

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function processHeroShots(_x10, _x11) {
        return _processHeroShots.apply(this, arguments);
      }

      return processHeroShots;
    }()
    /**
     * Replaces image src attributes with empty values and moving original URL to data attribute
     *
     * Image src="" attributes should be removed before parsing HTML into DOM tree.
     * This ensures the images aren't loaded automatically, as even de-attached from DOM image elements are
     * still triggering GET requests when created on Safari and Harman (webKit) head units.
     *
     * @param {String} html
     * @return {String}
     */

  }, {
    key: "replaceImageSources",
    value: function replaceImageSources(html) {
      return html.replace(/(src=".+?")/gi, function (match, src) {
        return 'data-' + src;
      });
    }
    /**
     * Skips blacklisted and text nodes tags from content
     *
     * @param {Node} el
     * @returns {Boolean}
     */

  }, {
    key: "isRedundant",
    value: function isRedundant(el) {
      return el.nodeType !== 1
      /* NodeType Element */
      || _lodash["default"].includes(['link', 'meta', 'title'], el.tagName);
    }
    /**
     * Checks if provided URL is internal or external
     * @param {string} url
     * @return {boolean}
     */

  }, {
    key: "isInternalUrl",
    value: function isInternalUrl(url) {
      var internalRegexp = new RegExp("^(".concat(_axios["default"].defaults.baseURL ? _axios["default"].defaults.baseURL + '|' : '', "/)"), 'i');
      return internalRegexp.test(url);
    }
    /**
     * Wrapper on axios-cancel
     * @param {string} requestId
     */

  }, {
    key: "cancelRequest",
    value: function cancelRequest(requestId) {
      _axios["default"].cancel(requestId);

      _retriable["default"].cancel(requestId);
    }
    /**
     * Sets the global base url for axios
     * @param {String} baseUrl
     */

  }, {
    key: "setGlobalBaseUrl",
    value: function setGlobalBaseUrl(baseUrl) {
      _axios["default"].defaults.baseURL = baseUrl;
    }
    /**
     * Loads runtime config overrides if needed
     * @param {string} url to load runtime overrides
     * @returns {Promise}
     */

  }, {
    key: "loadRuntimeConfig",
    value: function () {
      var _loadRuntimeConfig = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee10(url) {
        var config, res, _res$data, clientId, clientSecret, draftPreviewMode, baseUrl;

        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                config = (0, _index.getConfig)();
                _context10.prev = 1;
                _context10.next = 4;
                return _axios["default"].request({
                  url: url
                });

              case 4:
                res = _context10.sent;

                if (res && res.data) {
                  _res$data = res.data, clientId = _res$data.clientId, clientSecret = _res$data.clientSecret, draftPreviewMode = _res$data.draftPreviewMode, baseUrl = _res$data.baseUrl;
                  config.CLIENT_ID = typeof clientId !== 'undefined' ? clientId : config.CLIENT_ID;
                  config.CLIENT_SECRET = typeof clientSecret !== 'undefined' ? clientSecret : config.CLIENT_SECRET;
                  config.BASE_URL = typeof baseUrl !== 'undefined' ? baseUrl : config.BASE_URL;
                  config.FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW = typeof draftPreviewMode !== 'undefined' ? draftPreviewMode : config.FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW;
                }

                _context10.next = 10;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](1);

              case 10:
                return _context10.abrupt("return", config);

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[1, 8]]);
      }));

      function loadRuntimeConfig(_x12) {
        return _loadRuntimeConfig.apply(this, arguments);
      }

      return loadRuntimeConfig;
    }()
    /**
     * Returns the list of publication's pages which satisfy search query
     *
     * @return {Promise}
     */

  }, {
    key: "getSearchPages",
    value: function getSearchPages(_ref) {
      var publicationId = _ref.publicationId,
          searchQuery = _ref.searchQuery;

      var _getConfig10 = (0, _index.getConfig)(),
          FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW = _getConfig10.FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW;

      var url = FEATURE_ENABLED_DRAFT_CONTENT_PREVIEW ? "/api/v2/internal/contents/publications/".concat(publicationId, "/pages/search") : "/api/v2/contents/publications/".concat(publicationId, "/pages/search");
      return this.get({
        url: url,
        params: {
          contains: searchQuery
        }
      });
    }
  }]);

  return ContentDelivery;
}();

exports.ContentDelivery = ContentDelivery;

_defineProperty(ContentDelivery, "tokenType", 'Bearer');

var api = new ContentDelivery();
var _default = api;
exports["default"] = _default;